let PhoneNumberValidation;
PhoneNumberValidation = require("awesome-phonenumber");

export class Client {
  id?: string;
  gender?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  fly?: any;
  address?: any;

  public static makeid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  public static of(data: any): Client {
    const c: Client = new Client();
    const client = data?.data?.client;

    c.gender = client?.civility || "";
    c.firstName = client?.firstname;
    c.lastName = client?.lastname;
    c.email = client?.email;

    c.address = {
      firstName: client?.firstname,
      lastName: client?.lastname,
      company: client?.company || "",
      street: client?.no_and_street,
      city: client?.city,
      postCode: client?.zip_code,
      country: client?.country_code,
      phone: client?.country_dialling_code + client?.phone_number,
      email: client?.email,
      website: client?.website,
      latitude: client?.latitude,
      longitude: client?.longitude,
      name: client?.no_and_street.normalize("NFKD").replace(/[^a-zA-Z]+/g, "").replace(/\s/g, "") + client?.zip_code.replace(/[^0-9]+/g, "") + this.makeid(8),

    };
// valid and format phone number
    const regionCode = new PhoneNumberValidation(c.address.phone).getRegionCode();
    const pn = new PhoneNumberValidation(c.address.phone, regionCode);
    if (pn.isValid()) {
      c.address.phone = pn.getNumber("international");
    }

    c.fly = {
      date: data?.data?.context?.departure_date_utc,
      arrival: data?.data?.context?.arrival_airport_code,
      departure: data?.data?.context?.departure_airport_code,
    };
    return c;
  }
}